import { IDB_procedures, IDB_syncParamsProcedures } from '../IDB/IDB.dexie'
import { Sync_standardSync, type Sync_Params } from '../Sync/Sync.standardSync'
import { Serv_client } from '../Serv/Serv.client'
import { asyncDoNothing } from '../../../shared/lib/functional/function.no-deps'

export async function Proc_sync() {
    await Sync_standardSync({
        params: IDB_syncParamsProcedures(),
        sync,
        write: (response) => IDB_procedures().bulkPut(response.procedures),
        // Do not need to clear procedures as only soft hidden
        clear: asyncDoNothing,
    })
}

async function sync(params: Sync_Params) {
    const includeDeleted = true
    const response = await Serv_client.syncProcedures(params, includeDeleted)
    return response
}
